export function createFile(fileName: string, content: string) {
  var link = document.createElement('a');
  link.download = fileName;
  var blob = new Blob([content], { type: 'text/plain' });
  link.href = window.URL.createObjectURL(blob);
  link.click();
}

export function parseCsvData<T>(csv: string, action?: (item: T) => void): T[] {
  let allTextLines: any[] = []
  const lines: T[] = []
  allTextLines = csv.split(/\r\n|\n/)
  const keys = allTextLines
    .shift()
    .split(',')
    .map((x) => x.charAt(0).toLowerCase() + x.slice(1))

  while (allTextLines.length) {
    const line = allTextLines.shift()
    if (line === '') continue
    const arr = line.split(',')
    const obj = {}
    for (var i = 0; i < keys.length; i++) {
      obj[keys[i]] = arr[i]
    }
    action?.(obj as T)
    lines.push(obj as T)
  }
  return lines;
}